import { XIcon } from "lucide-react";
import AvatarButton from "@/components/AvatarButton";
import React from "react";
import { useHover } from "usehooks-ts";
import { cn } from "@/lib/utils";

export function MinimizedAvatar({
  onDismiss,
  children,
  disableDismiss,
}: {
  onDismiss?: () => void;
  children?: React.ReactNode;
  disableDismiss?: boolean;
}) {
  const ref = React.useRef<HTMLDivElement>(null);
  const isHover = useHover(ref);

  return (
    <div className={cn("pyne-minimized-avatar", isHover && "pyne-minimized-avatar--hover")} ref={ref}>
      {!disableDismiss && (
        <AvatarButton
          className="pyne-minimized-avatar__dismiss-btn"
          icon={<XIcon width={8} height={8} />}
          onClick={onDismiss}
          title="Dismiss"
        />
      )}
      {children}
    </div>
  );
}
